import { render, staticRenderFns } from "./Chapter3.vue?vue&type=template&id=382d1f5c&"
import script from "./Chapter3.vue?vue&type=script&lang=js&"
export * from "./Chapter3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports